import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

import EventListContentLoader from './EventListContentLoader';
import EventGridContentLoader from './EventGridContentLoader';
import EventKanbanContentLoader from './EventKanbanContentLoader';

const getContentLoaderForView = (view) => {
  switch (view) {
    case 'list':
      return <EventListContentLoader />;
    case 'grid':
      return <EventGridContentLoader />;
    case 'kanban':
      return <EventKanbanContentLoader />;
    default:
      return (
        <div
          style={{
            textAlign: 'center',
            margin: '1em',
          }}
        >
          <CircularProgress />
        </div>
      );
  }
};

export const ContentLoaderComponent = (props) => (
  <div>
    {getContentLoaderForView(props.view)}
  </div>
);

ContentLoaderComponent.propTypes = { view: PropTypes.string };

ContentLoaderComponent.defaultProps = { view: 'list' };

export default ContentLoaderComponent;
